import storeModule from '../../store-module'
import { defineStore } from 'pinia'

const url = 'dashboard/new-contacts'

export default defineStore(
  'dashboard-new-contacts',
  storeModule.createStoreModule('dashboard-new-contacts', {
    fetchFiltersURL: `${url}/filters`,
    fetchListURL: url
  })
)
